import {
  Radio,
  RadioGroup,
  Stack,
  IconButton,
  Button,
  Box,
  Dialog,
} from "@mui/material";
import { useState } from "react";
import { ArrowBackIos, ArrowForwardIos, Sync } from "@mui/icons-material/";
import FetchRequest from "./FetchRequest";

export default function ImageViewer(props) {
  // Fetch and store the URLs of the images belonging to the specific measure
  const images = FetchRequest("imageurls/" + props.id);

  // State hook to store the index number of the currently displayed image
  const [selectedImage, setSelectedImage] = useState(0);

  // Function that sets the selected image when radio button is clicked
  const handleRadio = (event) => {
    setSelectedImage(parseInt(event.target.value));
  };

  // Function that sets the selected image when 'next' button is clicked
  const nextImage = () => {
    setSelectedImage(Math.min(images.length - 1, selectedImage + 1));
  };

  // Function that sets the selected image when 'previous' button is clicked
  const previousImage = () => {
    setSelectedImage(Math.max(0, selectedImage - 1));
  };

  // State and function to handle imageclick: when the preview is clicked, opens a dialog with the fullsize image
  const [imageOpen, setImageOpen] = useState(false);

  const handleImageOpen = () => {
    setImageOpen(true);
  };
  const handleImageClose = () => {
    setImageOpen(false);
  };

  // Check if the 'images' array has been filled, otherwise return a loading button
  if (images) {
    // Create sequence of numbers with length=number of images
    var imagenumbers = Array.from(Array(images.length).keys());
    if (images.length > 0) {
      return (
        <>
          <Dialog open={imageOpen} onClose={handleImageClose} maxWidth="xl">
            <img src={images[selectedImage]} alt="measure dialog" />
          </Dialog>

          <Stack
            direction="row"
            justifyContent="center"
            sx={{ maxHeight: "90vh", minHeight: "30vh" }}
          >
            <IconButton onClick={previousImage}>
              <ArrowBackIos />
            </IconButton>
            <Stack
              direction="column"
              justifyContent="center"
              alignContent="center"
            >
              <Box sx={{ border: 1 }}>
                <Button onClick={handleImageOpen}>
                  <img
                    src={images[selectedImage]}
                    alt="measure preview"
                    width='360px'
                    />
                </Button>
                <RadioGroup
                  name="imageselector"
                  row
                  value={selectedImage}
                  onChange={handleRadio}
                >
                  {imagenumbers.map((number) => {
                    return <Radio size="small" value={number} key={number} />;
                  })}
                </RadioGroup>
              </Box>
            </Stack>
            <IconButton onClick={nextImage}>
              <ArrowForwardIos />
            </IconButton>
          </Stack>
        </>
      );
    } else {
      return null;
    }
  } else {
    return <Sync />;
  }
}
